export const GACHA_PORTFOLIO_REFRESH_EVENT = "gacha:portfolio-refresh"

export function requestGachaPortfolioRefresh() {
  window.dispatchEvent(new Event(GACHA_PORTFOLIO_REFRESH_EVENT))
}
